import { __module as a } from "./chunk755.js";
import { __require as p } from "./chunk648.js";
var C = a.exports, h;
function m() {
  return h ? a.exports : (h = 1, function(d, x) {
    (function(s, o) {
      d.exports = o(p());
    })(C, function(s) {
      return function() {
        var o = s, g = o.lib, c = g.WordArray, u = o.enc;
        u.Utf16 = u.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(t) {
            for (var e = t.words, f = t.sigBytes, r = [], n = 0; n < f; n += 2) {
              var v = e[n >>> 2] >>> 16 - n % 4 * 8 & 65535;
              r.push(String.fromCharCode(v));
            }
            return r.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(t) {
            for (var e = t.length, f = [], r = 0; r < e; r++)
              f[r >>> 1] |= t.charCodeAt(r) << 16 - r % 2 * 16;
            return c.create(f, e * 2);
          }
        }, u.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(t) {
            for (var e = t.words, f = t.sigBytes, r = [], n = 0; n < f; n += 2) {
              var v = i(e[n >>> 2] >>> 16 - n % 4 * 8 & 65535);
              r.push(String.fromCharCode(v));
            }
            return r.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(t) {
            for (var e = t.length, f = [], r = 0; r < e; r++)
              f[r >>> 1] |= i(t.charCodeAt(r) << 16 - r % 2 * 16);
            return c.create(f, e * 2);
          }
        };
        function i(t) {
          return t << 8 & 4278255360 | t >>> 8 & 16711935;
        }
      }(), s.enc.Utf16;
    });
  }(a), a.exports);
}
export {
  m as __require
};
